import TaskRow from "./TaskRow";
import RoundNewButton from "../../../../layout/Buttons/RoundNewButton";
import { useEffect, useState, Fragment } from "react";
import { Row, Col } from "react-bootstrap";
import timeingStuff from "@serie3/freelancesplaceapi/Domain/Shared/timeingStuff";

const TasksTable = ({
  tasks,
  deleteTaskFunction,
  editTaskFunction,
  createNewTask,
  addDefault,
  selected,
  setSelected,
  startSelection = false,
}) => {
  const fullWorkDay = 8 * 60 * 60;
  const [totalTime, setTotalTime] = useState(0);
  const [totalOvertime, setTotalOvertime] = useState(0);

  let tmpTotalTime = 0;
  let tmpTotalOvertime = 0;
  let currentmonth = -1;

  useEffect(() => {
    tasks.map((task, index) => {
      tmpTotalTime += task.total_time;
      tmpTotalOvertime += fullWorkDay - task.total_time;
      if (index === tasks.length - 1) {
        setTotalTime(tmpTotalTime);
        setTotalOvertime(tmpTotalOvertime);
      }
    });
  }, [tasks]);

  // Pre-compute per-month totals
  const monthTotals = {};
  if (tasks) {
    tasks.forEach((task) => {
      const d = new Date(task.date);
      const key = `${d.getFullYear()}-${d.getMonth()}`;
      if (!monthTotals[key]) monthTotals[key] = { totalTime: 0, pauseTime: 0 };
      monthTotals[key].totalTime += task.total_time || 0;
      monthTotals[key].pauseTime += task.pause_time || 0;
    });
  }

  const HeaderRow = ({ task }) => {
    const monthChange = new Date(task.date);
    const key = `${monthChange.getFullYear()}-${monthChange.getMonth()}`;
    const totals = monthTotals[key] || { totalTime: 0, pauseTime: 0 };

    return (
      <tr>
        <td
          colSpan={9}
          style={{
            background: "#e8f0fe",
            color: "#1a73e8",
            fontWeight: 700,
            fontSize: "0.8rem",
            textTransform: "uppercase",
            letterSpacing: "0.08em",
            padding: "8px 16px",
            borderRadius: "6px",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <span>
              {monthChange.toLocaleString("default", { month: "long" })}{" "}
              {monthChange.getFullYear()}
            </span>
            <div style={{ display: "flex", gap: "20px", fontSize: "0.78rem", fontWeight: 600 }}>
              <span>
                <span style={{ opacity: 0.7, fontWeight: 500, marginRight: "5px" }}>Total</span>
                {timeingStuff.secondsToTimeString(totals.totalTime)}
              </span>
              <span>
                <span style={{ opacity: 0.7, fontWeight: 500, marginRight: "5px" }}>Breaks</span>
                {timeingStuff.convertToHHmm(totals.pauseTime)}
              </span>
            </div>
          </div>
        </td>
      </tr>
    );
  };

  const thStyle = {
    fontSize: "0.72rem",
    fontWeight: 700,
    textTransform: "uppercase",
    letterSpacing: "0.07em",
    color: "#9e9e9e",
    padding: "10px 12px",
    borderBottom: "2px solid #f0f0f0",
    background: "#fff",
    whiteSpace: "nowrap",
  };

  return (
    <>
      <div style={{ borderRadius: "12px", boxShadow: "0 2px 16px rgba(0,0,0,0.08)", overflow: "hidden", background: "#fff" }}>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr>
              {startSelection && <th style={thStyle}></th>}
              <th style={{ ...thStyle, textAlign: "left" }}>Date</th>
              <th style={{ ...thStyle, textAlign: "center" }}>Start</th>
              <th style={{ ...thStyle, textAlign: "center" }}>End</th>
              <th style={{ ...thStyle, textAlign: "center" }}>Pause</th>
              <th style={{ ...thStyle, textAlign: "center" }}>Total</th>
              <th style={{ ...thStyle, textAlign: "center" }}>Missed</th>
              <th style={{ ...thStyle, textAlign: "left" }}>Documentation</th>
              <th style={thStyle}></th>
            </tr>
            <tr style={{ background: "#fafafa" }}>
              <td colSpan={startSelection ? 5 : 4} style={{ padding: "8px 12px" }}></td>
              <td style={{ padding: "8px 12px", textAlign: "center", fontWeight: 700, fontSize: "0.88rem", color: "#212121" }}>
                {timeingStuff.secondsToTimeString(totalTime)}
              </td>
              <td style={{
                padding: "8px 12px",
                textAlign: "center",
                fontWeight: 700,
                fontSize: "0.88rem",
                color: totalOvertime > 0 ? "#c62828" : "#2e7d32",
              }}>
                {timeingStuff.secondsToTimeString(totalOvertime, true)}
              </td>
              <td colSpan={2} style={{ padding: "8px 12px" }}></td>
            </tr>
          </thead>
          <tbody>
            {tasks
              ? tasks.map((task, index) => {
                  let taskMonth = new Date(task.date).getMonth() + 1;
                  let showHeaderRow = false;
                  if (taskMonth !== currentmonth) {
                    showHeaderRow = true;
                    currentmonth = taskMonth;
                  }
                  return (
                    <Fragment key={task.id}>
                      {showHeaderRow && <HeaderRow task={task} />}
                      <TaskRow
                        task={task}
                        deleteTaskFunction={deleteTaskFunction}
                        editTaskFunction={editTaskFunction}
                        startSelection={startSelection}
                        selected={selected}
                        setSelected={setSelected}
                      />
                    </Fragment>
                  );
                })
              : null}
          </tbody>
        </table>
      </div>
      <br />
      {addDefault && (
        <Row>
          <Col className="text-center">
            <RoundNewButton createNew={addDefault} />
          </Col>
        </Row>
      )}
    </>
  );
};

export default TasksTable;
